import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { JobStatus } from '@jobos/shared/types/job';

export type JobPhase = 'all' | 'quoting' | 'building' | 'billing' | 'other';

interface JobPhaseSelectorProps {
  value: JobPhase;
  onChange: (phase: JobPhase) => void;
}

const PHASE_OPTIONS = [
  { value: 'all' as JobPhase, label: 'All Jobs' },
  { value: 'quoting' as JobPhase, label: 'Phase 1: Quoting' },
  { value: 'building' as JobPhase, label: 'Phase 2: Building' },
  { value: 'billing' as JobPhase, label: 'Phase 3: Billing' },
  { value: 'other' as JobPhase, label: 'Other' },
];

export const PHASE_TO_STATUSES: Record<JobPhase, JobStatus[] | null> = {
  all: null,
  quoting: ['quote_requested', 'estimate_sent'],
  building: ['awarded', 'in_progress'],
  billing: ['completed'],
  other: ['not_awarded'],
};

export function JobPhaseSelector({ value, onChange }: JobPhaseSelectorProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full sm:w-[200px]">
        <SelectValue placeholder="Select phase..." />
      </SelectTrigger>
      <SelectContent>
        {PHASE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
